var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMprofile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2582 1C14.8508 1 17.7632 3.91203 17.7632 7.505C17.7632 9.69376 16.6824 11.6298 15.0255 12.8088C18.2607 14.2522 20.516 17.4969 20.516 21.2682H18.516C18.516 17.2598 15.2661 14.0102 11.258 14.0102C7.24929 14.0102 4 17.2595 4 21.2682H2C2 17.4967 4.25494 14.2521 7.49025 12.809C5.83307 11.6299 4.7522 9.69388 4.7522 7.505C4.7522 3.91185 7.66478 1 11.2582 1ZM11.2582 3C8.76924 3 6.7522 5.01653 6.7522 7.505C6.7522 9.99347 8.76924 12.01 11.2582 12.01C13.7463 12.01 15.7632 9.99334 15.7632 7.505C15.7632 5.01666 13.7463 3 11.2582 3Z",
    fill: "#54545C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMprofile);
export default __webpack_public_path__ + "static/media/mprofile.cbcd20c30b6844c442b519df5844cf3b.svg";
export { ForwardRef as ReactComponent };